import './label.less'
import { capitalizeFirstLetter } from '../../utils/stringUtil'
import { Typography, TypographyProps } from '@lightbeamai/design-system'
import classNames from 'classnames'
import React from 'react'
import { useIntl } from 'react-intl'

const Label = ({
  transId,
  text,
  required,
  className,
  capitalise,
  variant = 'baseMinus2',
  ...rest
}: {
  transId?: string
  text?: string
  required?: boolean
  className?: string
  capitalise?: boolean
} & TypographyProps) => {
  const intl = useIntl()
  const label = text ?? intl.formatMessage({ id: transId })
  return (
    <Typography
      className={classNames('lb-form-label', className, {
        required: required
      })}
      color="primary"
      type="medium"
      variant={variant}
      {...rest}
    >
      {capitalise ? capitalizeFirstLetter(label) : label}
    </Typography>
  )
}

export default Label
